import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function Stat({ value, label, tone, className, ...rest }) {
    return (_jsxs("div", { className: cn("fwfa-stat", className), "data-tone": tone, ...rest, children: [_jsx("span", { className: "fwfa-stat-value", children: value }), _jsx("span", { className: "fwfa-stat-label", children: label })] }));
}
export function StatRow({ compact, spread, className, ...rest }) {
    return (_jsx("div", { className: cn("fwfa-stat-row", compact && "fwfa-stat-row--compact", spread && "fwfa-stat-row--spread", className), ...rest }));
}
//# sourceMappingURL=Stat.js.map